import { LayerSizeType } from '../types'

export class ClusterModel {
  constructor(
    public id: number,
    public size: LayerSizeType,
    public coordinates: [number, number],
    public fontSize: number,
    public weight: number,
    public radius: number,
    public opacity: number,
    public usersCount: number,
    public isVisible?: boolean
  ) {}
}
